export const ROUTES = {
  HOME: '/',
  IMPRESSUM: '/impressum',
  GALEREA: '/galerea',
  NOTFOUNDPAGE: '/*',
  ABOUT: '/about',
  PRAXIS: '/praxis',
  DATENSCHUTZ: '/datenschutz',
};
